import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {
    path: '',
    redirectTo: environment.PAGES.asignaturas.url,
    pathMatch: 'full',
  },
  { path: '/asignaturas',
    redirectTo: environment.PAGES.asignaturas.url,
    pathMatch: 'full' },
    { path: '/home',
    redirectTo: environment.PAGES.asignaturas.url,
    pathMatch: 'full' },
  {
    path: environment.PAGES.asignaturas.url,
    loadChildren: () =>
      import('./project/pages/asignaturas/asignaturas.module').then( m => m.AsignaturasPageModule)
  },

  {
    path: 'notas',
    loadChildren: () => import('./project/pages/notas/notas.module').then( m => m.NotasPageModule)
  },

 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
